import Image from "../../../components/Image";
import H4 from "../../../components/global/H4";
import P from "../../../components/global/P";
import { css } from "emotion";
import { max } from "../../../utils/CssUtils";
import H3 from "../../../components/global/H3";

const featuresStyle = css({
  maxWidth: 1040,
  margin: "0 auto",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  background: "transparent",
  marginBottom: -32,
  h3: {
    textAlign: "center",
    width: "100%",
    marginBottom: 48
  },
  [max(759)]: {
    h3: {
      marginBottom: 32
    }
  }
});

const featureBlockStyle = css({
  maxWidth: 300,
  textAlign: "center",
  marginBottom: 32,
  minHeight: 219,
  [max(759)]: {
    minHeight: "auto",
    marginLeft: "auto",
    marginRight: "auto"
  },
  img: {
    marginBottom: 12,
    maxWidth: 100,
    maxHeight: 70
  },
  h4: {
    marginBottom: 12,
    letterSpacing: -0.5
  }
});

const Features = ({ featureObj }) => {
  return (
    <div className={featuresStyle}>
      <H3>Discover features you won’t find anywhere else</H3>
      {featureObj.map(feature => (
        <div className={featureBlockStyle}>
          <Image imageURL={feature.icon} alt="" />
          <H4>{feature.title}</H4>
          <P>{feature.text}</P>
        </div>
      ))}
    </div>
  );
};

export default Features;
